import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from 'axios';

// Base URL for API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle common errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Generic API methods with debug logging
export const apiClient = {
  get: <T>(url: string, config?: AxiosRequestConfig) => {
    console.log('📤 GET request →', url);
    return axiosInstance.get<T>(url, config).then(res => res.data);
  },
  
  post: <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    console.log('📤 POST request →', url, '\nPayload:', data);
    return axiosInstance.post<T>(url, data, config).then(res => res.data);
  },
  
  put: <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    console.log('📤 PUT request →', url, '\nPayload:', data);
    return axiosInstance.put<T>(url, data, config).then(res => res.data);
  },
  
  patch: <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    console.log('📤 PATCH request →', url, '\nPayload:', data);
    return axiosInstance.patch<T>(url, data, config).then(res => res.data);
  },
  
  delete: <T>(url: string, config?: AxiosRequestConfig) => {
    console.log('📤 DELETE request →', url);
    return axiosInstance.delete<T>(url, config).then(res => res.data);
  },
};

export default apiClient;